import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { createCita } from "../services/cita.service";

import { successNotification, dangerNotification } from '../../../redux/slices/ui';

export const useCitaNueva = (id) => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const createCitaMutation = useMutation({
        mutationFn: createCita,
        onSuccess: ({ inactivoFlag, horarioFlag, empalmadaFlag, cita }, variables, context) => {
            if(inactivoFlag){
                variables.onInactivo();
            }else if(horarioFlag){
                variables.onHorario();
            }else if(empalmadaFlag){
                variables.onEmpalmada();
            }else{
                queryClient.invalidateQueries({ queryKey: ['citas', id] });
                variables.onComplete();
                variables.onSuccess();
                dispatch(successNotification('Cita creada'));
            }
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        createCitaMutation,
    }
}